/**
 * <EventCard> — la carte d'événement du livre, nue (molecule).
 *
 * Chap. 06, « Les temps forts », vignette « Événement » : un intitulé, l'information qui compte en
 * titre, une phrase, un bouton-poussoir. C'est la forme d'une offre ou d'une annonce, pas d'une
 * tâche (une tâche est une ligne « À faire », `<TodoRow>`).
 *
 * **Elle ne s'encadre pas elle-même.** Le dégradé des temps forts se pose au plus une fois par
 * écran : c'est la page qui décide si cette carte le porte (`<HighlightFrame>` autour d'elle) ou
 * s'il est déjà pris. `<StageOfferBanner>` en est le cas où il l'est — la même carte, sur le jaune.
 *
 * Les mots arrivent écrits ; le bouton garde sa taille, il ne s'étire pas.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { Button } from "../../atoms/Buttons/Button"
import { Stack } from "../../atoms/containers/Stack"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { Text } from "../../atoms/typography/Text"
import { Title } from "../../atoms/typography/Title"
import { Card } from "../Card"

export type EventCardProps = {
    /** L'intitulé, en petites capitales — le nom de l'événement. Absent : la carte s'ouvre sur son titre. */
    label?: string
    title: string
    message?: string
    actionLabel: string
    onAction: () => void
    testID?: string
}

export function EventCard(props: EventCardProps) {
    const { label, title, message, actionLabel, onAction, testID } = props

    return (
        <Card p="5" testID={testID}>
            <Stack gap="3">
                {label != null && label !== "" && <SectionLabel>{label}</SectionLabel>}
                <Title size="text-2xl">{title}</Title>
                {message != null && message !== "" && (
                    <Text size="text-md" color="text-muted">
                        {message}
                    </Text>
                )}
                <View style={styles.action}>
                    <Button label={actionLabel} onPress={onAction} />
                </View>
            </Stack>
        </Card>
    )
}

const styles = StyleSheet.create((theme) => ({
    action: { alignSelf: "flex-start", marginTop: theme.spacing["1"] },
}))
